/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const DownloadArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={19}
    height={18}
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="DownloadArrow">
    <g
      clipPath="url(#DownloadArrowA)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3.004 12.75v1.5a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5v-1.5M5.254 8.25 9.004 12l3.75-3.75M9.004 3v9" />
    </g>
    <defs>
      <clipPath id="DownloadArrowA">
        <path fill="currentColor" transform="translate(.004)" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default DownloadArrow;
